import { jsx as E } from "react/jsx-runtime";
import c from "react";
import S from "classnames";
import o from "./index.es661.js";
const T = "link-component", V = c.forwardRef(
  ({
    color: d = "brand",
    size: i = "medium",
    weight: l = "regular",
    hideUnderline: f = !0,
    testId: m = T,
    children: p,
    disabled: e,
    onClick: t,
    isEllipsis: u,
    tabIndex: v = 0,
    href: I,
    ...k
  }, h) => {
    let r, a = I, s = v;
    t && (r = "button"), e && (a = void 0, s = -1);
    const D = c.useCallback(
      (n) => {
        if (t) {
          const x = n.code === "Enter" && !a;
          (n.code === "Space" || x) && (n.preventDefault(), t(n));
        }
      },
      [t, a]
    ), w = S(
      o.link,
      o[`color-${e ? "disabled" : d}`],
      o[`size-${i}`],
      o[`weight-${l}`],
      {
        [o["no-underline"]]: f,
        [o.ellipsis]: u
      }
    );
    return /* @__PURE__ */ E(
      "a",
      {
        ...k,
        href: a,
        className: w,
        "aria-disabled": e,
        role: r,
        "data-testid": m,
        "data-pl-size": i,
        "data-pl-weight": l,
        onClick: e ? void 0 : t,
        onKeyDown: e ? void 0 : D,
        ref: h,
        tabIndex: s,
        children: p
      }
    );
  }
);
export {
  T as LINK_DEFAULT_TESTID,
  V as Link
};
//# sourceMappingURL=index.es68.js.map
